import { createContext,useReducer } from "react";
import TodoReducer from "../reducers/TodoReducer";

export const TodosContext = createContext([]);

const TodosProvider=({children})=>{
    const [todoList,dispatch]=useReducer(TodoReducer,[])
    
    return(
        <TodosContext.Provider value={{todoList:todoList,dispatch:dispatch}} >
            {children}
        </TodosContext.Provider>
    )
}
export default TodosProvider;